import { s3ImageLink } from "@/utils/links";
import type { CreatorAvatarFrameType } from "./resolveCreatorAvatarFrameType";

export {
  resolveCreatorAvatarFrameType,
  type CreatorAvatarFrameType,
} from "./resolveCreatorAvatarFrameType";

export default function CreatorAvatarFrame({
  type,
  size,
}: {
  type: CreatorAvatarFrameType;
  size: 56 | 80;
}) {
  const src =
    type === "your-reinvite"
      ? `${s3ImageLink}reinvited-avatar-frame.png`
      : `${s3ImageLink}${type === "wishlist" ? "wishlist" : "aha-picks"}-${size}.png`;

  return (
    <img
      src={src}
      alt=""
      aria-hidden="true"
      className="h-full w-full flex-shrink-0 object-cover"
    />
  );
}
